import React, { useState } from 'react'
import { Chart } from './chart'
import './styles.scss'
interface BaseChartProps {
  data: namedataElement[]
  selected: namedataElement[]
  colors: string[]
}
export const NameChart: React.FC<BaseChartProps> = ({
  data,
  selected,
  colors
}) => {
  const [drawData, setDrawData] = useState(data)

  return (
    <div className='ui vertical very fitted segment'>
      <Chart data={drawData} selected={selected} colors={colors} />
    </div>
  )
}
